import { RootState } from "../../../utils/types/root-state";


export const getAuthState = (state: RootState) => state.auth;
